/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import Select from 'react-select';
import { Redirect} from "react-router-dom";
/**
 * Handles the selection of products
 */
class SelectorProduct extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            sessionValid: true,
            options: [] // The options to fill the selection
        };
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        // This is promise
        let apiCall = ApiCalls.getUserSubscribedItems();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{
            this.setState({
                sessionValid: data.SessionValid
            });
            // Now fill the selections
            for (let i = 0; i < data.Items.length; i++)
            {
                arrOptions.push({value: data.Items[i].ItemId, label: data.Items[i].Name});
            }
        }).then(()=>{
            // Then, set the state
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     */
    handleChange = (selectedOption) => {
        this.setState({value: selectedOption }, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        if(!this.state.sessionValid)
            return (<Redirect  to={{
                pathname: "/login"
            }}/>);

        return (
            <Select onChange={this.handleChange} value={this.props.value} options={this.state.options}/>
        )
    }
}

export default SelectorProduct;